import { useEffect, useRef, useState } from 'react'

import { cn } from '../../utils/cn'
import { Button } from './button'

export function ExpandableContent({ children }: { children: React.ReactNode }) {
  const [expanded, setExpanded] = useState(false)
  const [overflows, setOverflows] = useState(false)
  const outerRef = useRef<HTMLDivElement>(null)
  const innerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const outer = outerRef.current
    const inner = innerRef.current
    if (!outer || !inner) return
    const check = () => {
      if (expanded) return
      setOverflows(outer.scrollHeight > outer.clientHeight + 1)
    }
    check()
    const observer = new ResizeObserver(check)
    observer.observe(inner)
    return () => observer.disconnect()
  }, [expanded])

  return (
    <div className="relative">
      <div
        ref={outerRef}
        className={cn('overflow-hidden', !expanded && 'max-h-100')}
        onClick={() => {
          if (!expanded && overflows) setExpanded(true)
        }}
      >
        <div ref={innerRef}>{children}</div>
      </div>
      {overflows && !expanded && (
        <Button
          type="button"
          variant="link"
          className="absolute inset-x-0 bottom-0 flex h-16 w-full items-end justify-center rounded-none bg-linear-to-t from-white via-white/85 to-transparent pb-1 hover:underline"
          onClick={() => setExpanded(true)}
        >
          Show more
        </Button>
      )}
      {overflows && expanded && (
        <Button
          type="button"
          variant="link"
          size="sm"
          className="mt-2 px-0 hover:underline"
          onClick={() => setExpanded(false)}
        >
          Show less
        </Button>
      )}
    </div>
  )
}
